import { Select, Switch } from 'antd';
import React from 'react';
import { useCollaborativeList } from '../containers/CollaborativeListDataStore';
import AlertCandidate from './AlertCandidate';
import AlertMethod from './AlertMethod';
import AlertType from './AlertType';
import './manageListNotifications.less';
import { withLocalize } from '../../Localization/withLocalize';

const { Option } = Select;

function ManageListNotifications({ listId, isVerticalView, translate }) {
	const collaborativeListDataStore = useCollaborativeList();

	const getActiveSwitch = (alertType, alert) => (
		<Switch
			loading={collaborativeListDataStore.state.areAlertsLoading}
			checkedChildren={translate('yes')}
			unCheckedChildren={translate('no')}
			defaultChecked={alert ? true : false}
			checked={alert ? true : false}
			onChange={e => toggleAlert(e, alertType, alert)}
		/>
	);

	const getNotificationTypeSelect = (alertType, alert) => {
		const selectValue = alert
			? alert.alertMethod
			: AlertMethod.Notification.key;
		return (
			<div className="notification-type-select">
				<Select
					onChange={e =>
						handleSelectChange(e, alert, 'method', alertType)
					}
					defaultValue={selectValue}
					value={selectValue}>
					<Option value={AlertMethod.Notification.key}>
						{translate(AlertMethod.Notification.labelId, {
							companyName: 'Edelweiss',
						})}
					</Option>
					<Option value={AlertMethod.Email.key}>
						{translate(AlertMethod.Email.labelId)}
					</Option>
					<Option value={AlertMethod.Text.key}>
						{translate(AlertMethod.Text.labelId)}
					</Option>
				</Select>
			</div>
		);
	};

	const getQualifierSelect = (alertType, alert) => {
		const selectValue = alert
			? alert.alertCandidate
			: AlertCandidate.All.key;
		return (
			<div className="qualifier-select">
				<Select
					onChange={e =>
						handleSelectChange(e, alert, 'candidate', alertType)
					}
					defaultValue={selectValue}
					value={selectValue}>
					<Option value={AlertCandidate.All.key}>
						{translate(AlertCandidate.All.labelId)}
					</Option>
					<Option value={AlertCandidate.JustThoseUserHasTouched.key}>
						{translate(
							AlertCandidate.JustThoseUserHasTouched.labelId,
						)}
					</Option>
				</Select>
			</div>
		);
	};

	const getVerticalViewAlertTypeRow = (alertType, alert) => (
		<div className="notification-type-row">
			<div className="header">
				<span className="title">{translate(alertType.labelId)}</span>
				{getActiveSwitch(alertType, alert)}
			</div>
			<div className="alert-type-section">
				{translate('alert_type')}:
				{getNotificationTypeSelect(alertType, alert)}
			</div>
			{alertType.doOfferCandidate && (
				<div className="qualifier-section">
					{translate('qualifier')}:
					{getQualifierSelect(alertType, alert)}
				</div>
			)}
		</div>
	);

	const getHorizontalViewAlertTypeRow = (alertType, alert) => (
		<tr>
			<td>
				<span className="alert-type-label">
					{translate(alertType.labelId)}
				</span>
			</td>
			<td>{getActiveSwitch(alertType, alert)}</td>
			<td>{getNotificationTypeSelect(alertType, alert)}</td>
			{alertType.doOfferCandidate && (
				<td>{getQualifierSelect(alertType, alert)}</td>
			)}
		</tr>
	);

	const getAlertByType = alertType => {
		const { alerts } = collaborativeListDataStore.state;
		const alert =
			Array.isArray(alerts) &&
			alerts.find(al => al.alertType === alertType.key);
		return alert;
	};

	const getAlertTypeRow = alertType => {
		const alert = getAlertByType(alertType);
		return isVerticalView
			? getVerticalViewAlertTypeRow(alertType, alert)
			: getHorizontalViewAlertTypeRow(alertType, alert);
	};

	const handleSelectChange = (value, alert, alertAttribute, alertType) => {
		if (alert) {
			if (alertAttribute === 'method') {
				alert.alertMethod = value;
			} else {
				alert.alertCandidate = value;
			}
			collaborativeListDataStore.updateAlert(alert, alertAttribute);
		} else {
			var newAlert = {};
			newAlert.listId = listId;
			newAlert.alertType = alertType.key;
			newAlert.alertMethod =
				alertAttribute === 'method'
					? value
					: AlertMethod.Notification.key;
			newAlert.alertCandidate =
				alertAttribute === 'candidate' ? value : AlertCandidate.All.key;
			collaborativeListDataStore.createNewAlert(newAlert);
		}
	};

	const toggleAlert = (e, alertType, alert) => {
		if (e === true) {
			var newAlert = {};
			newAlert.listId = listId;
			newAlert.alertType = alertType.key;
			newAlert.alertMethod = AlertMethod.Notification.key;
			newAlert.alertCandidate = AlertCandidate.All.key;
			collaborativeListDataStore.createNewAlert(newAlert);
		} else {
			collaborativeListDataStore.deleteAlert(alert.id);
		}
	};

	const getAlertTypeRows = () => (
		<>
			{getAlertTypeRow(AlertType.AddOrRemoved)}
			{getAlertTypeRow(AlertType.Voted)}
			{getAlertTypeRow(AlertType.Commented)}
		</>
	);

	const getHorizontalView = () => (
		<>
			<div className="main-header">
				{translate('manage_list_notifications')}
			</div>
			<table className="notifications-table">
				<tr>
					<th className="table-header">
						{translate('type_of_activity')}
					</th>
					<th className="table-header">{translate('active')}?</th>
					<th className="table-header">{translate('mechanism')}</th>
					<th className="table-header">{translate('qualifier')}</th>
				</tr>
				{getAlertTypeRows()}
			</table>
		</>
	);

	const getVerticalView = () => getAlertTypeRows();

	return (
		<div
			className={`manage-list-notifications ${
				isVerticalView ? 'vertical-view' : 'horizontal-view'
			}`}>
			{isVerticalView ? getVerticalView() : getHorizontalView()}
		</div>
	);
}

export default withLocalize(ManageListNotifications);
